import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { __ } from "../../../utils";
import { useStores } from "../../../store";
const BlockerNoticeNotActive = observer((param)=>{
    let { style } = param;
    const { optionStore: { isBlockerActive, allBlockerCount } } = useStores();
    return !isBlockerActive && allBlockerCount > 0 && /*#__PURE__*/ _jsx("div", {
        className: "notice notice-warning inline below-h2 notice-alt",
        style: style,
        children: /*#__PURE__*/ _jsxs("p", {
            children: [
                __("Content Blockers are globally deactivated in the settings and are therefore not displayed on your website."),
                " ",
                "• ",
                /*#__PURE__*/ _jsx("a", {
                    href: "#/settings",
                    children: __("Enable now")
                })
            ]
        })
    });
});
export { BlockerNoticeNotActive };
